import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const sum = /* #__PURE__ */ Data$dFoldable.foldlArray(Data$dSemiring.numAdd)(0.0);
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const currencyIsSymbol = {reflectSymbol: () => "currency"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const contentsIsSymbol = {reflectSymbol: () => "contents"};
const encodeWithOptionsOther1 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther2 = /* #__PURE__ */ (() => {
  const encode1$1 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(quantityIsSymbol)(encodeWithOptionsOther1))({
    reflectSymbol: () => "id"
  })(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
  return {encodeWithOptions: v => encode1$1};
})();
const encodeRecordCons3 = /* #__PURE__ */ Foreign$dGeneric$dClass.encodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.encodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
  reflectSymbol: () => "value"
})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(currencyIsSymbol)(encodeWithOptionsOther))(contentsIsSymbol)(encodeWithOptionsOther2);
const encode = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.encodeRecordCons()(encodeRecordCons3)({reflectSymbol: () => "content_type"})(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const encode1 = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
  reflectSymbol: () => "value"
})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "num_items"})(encodeWithOptionsOther1))(currencyIsSymbol)(encodeWithOptionsOther))(contentsIsSymbol)(encodeWithOptionsOther2).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const encode2 = /* #__PURE__ */ (() => encodeRecordCons3.encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const itemValue = item => Data$dInt.toNumber(Data$dRecord.unsafeGet("price")(item)) / 100.0 * Data$dInt.toNumber(Data$dRecord.unsafeGet("quantity")(item));
const itemToContent = item => ({id: Data$dRecord.unsafeGet("name")(item), quantity: Data$dRecord.unsafeGet("quantity")(item)});
const toPlatformEvent = currency => v => {
  if (v.tag === "AddToCart") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "AddToCart",
        value: encode({
          content_type: "product",
          contents: [{id: Data$dRecord.unsafeGet("name")(v._1), quantity: Data$dRecord.unsafeGet("quantity")(v._1)}],
          value: itemValue(v._1),
          currency
        })
      }
    );
  }
  if (v.tag === "LocateMe") { return Data$dMaybe.Nothing; }
  if (v.tag === "RemoveFromCart") { return Data$dMaybe.Nothing; }
  if (v.tag === "BeginCheckout") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "InitiateCheckout",
        value: encode1({
          contents: Data$dFunctor.arrayMap(itemToContent)(Data$dRecord.unsafeGet("items")(v._1)),
          value: sum(Data$dFunctor.arrayMap(itemValue)(Data$dRecord.unsafeGet("items")(v._1))),
          num_items: length(Data$dRecord.unsafeGet("items")(v._1)),
          currency
        })
      }
    );
  }
  if (v.tag === "Purchase") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "Purchase",
        value: encode2({
          contents: Data$dFunctor.arrayMap(itemToContent)(Data$dRecord.unsafeGet("items")(v._1)),
          value: Data$dInt.toNumber(Data$dRecord.unsafeGet("total")(v._1)) / 100.0,
          currency
        })
      }
    );
  }
  if (v.tag === "SetCheckoutOption") { return Data$dMaybe.Nothing; }
  if (v.tag === "SuggestionResult") { return Data$dMaybe.Nothing; }
  if (v.tag === "ExperienceImpression") { return Data$dMaybe.Nothing; }
  if (v.tag === "NotOverlappingDishes") { return Data$dMaybe.Nothing; }
  if (v.tag === "VisitPage") { return Data$dMaybe.Nothing; }
  if (v.tag === "ReviewGoogleLinkShown") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
export {
  contentsIsSymbol,
  currencyIsSymbol,
  encode,
  encode1,
  encode2,
  encodeRecordCons3,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  itemToContent,
  itemValue,
  length,
  quantityIsSymbol,
  sum,
  toPlatformEvent
};
